import { parseKeywordIntegratedSearchQnaVo } from '@/parsers/search';

import { useGetkeywordSearchQnaQuery } from './search.gql.impl';

const KEYWORD_SEARCH_SIZE = 4;

const useGetKeywordIntegratedSearchQna = (keyword: string) => {
  const { data: keywordSearchQna, isLoading: isKeywordSearchQnaLoading } =
    useGetkeywordSearchQnaQuery(
      {
        request: {
          keyword,
          size: KEYWORD_SEARCH_SIZE,
        },
      },
      {
        select: parseKeywordIntegratedSearchQnaVo,
        enabled: keyword.length > 0,
      },
    );

  return {
    keywordSearchQna,
    isKeywordSearchQnaLoading,
  };
};

export default useGetKeywordIntegratedSearchQna;
